import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { clearPasswordResetState, forgotPassword } from '../store/authentication.action';
import { Observable } from 'rxjs';
import { selectAuthenticationError, selectPasswordResetState } from '../store/authentication.selector';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { PrimaryButtonComponent } from '../../shared/buttons/primary-button.component';
import { TertiaryButtonComponent } from '../../shared/buttons/tertiary-button.component';
import { LinkButtonComponent } from '../../shared/buttons/link-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-password-reinitialization',
  templateUrl: `./password-reinitialization.component.html`,
  styleUrls: ['../css/authentication.scss'],
  imports: [
    TranslocoDirective,
    ReactiveFormsModule,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    PrimaryButtonComponent,
    TertiaryButtonComponent,
    LinkButtonComponent,
    AsyncPipe,
  ],
})
export class PasswordReinitializationComponent implements OnInit {
  signInForm: UntypedFormGroup;
  error$: Observable<Error | undefined>;
  completed: Observable<boolean>;
  supportEmail = `mailto:${environment.supportEmail}`;
  readonly email = this.formBuilder.control('', [Validators.required, Validators.email]);

  constructor(private store: Store, private formBuilder: UntypedFormBuilder, private router: Router) {
    this.completed = this.store.select(selectPasswordResetState);
    this.signInForm = this.formBuilder.group({
      email: this.email,
    });
    this.error$ = this.store.select(selectAuthenticationError);
  }

  ngOnInit(): void {
    this.store.dispatch(clearPasswordResetState());
  }

  sendPasswordReset() {
    this.store.dispatch(
      forgotPassword({
        email: this.signInForm.value.email,
      })
    );
  }

  signin() {
    this.router.navigate(['/signin']);
  }
}
